<template>
  <div class="">
    <div class="pa-6 pb-16">
      <div loader-height="2" class="shadow-off d-flex flex-column gap-6" :loading="loading" :disabled="loading">
        <!-- Title -->
        <div class="d-flex align-center">
          <PageHeader 
            :title="$nova.labelsName('access_management','threshold_label','Role Management')"
            :loading="loading"
            @refresh="refreshData"
          />

          <v-spacer/>
          
          <CountToolbar 
            :pendingRequestCount="pendingrequestlist.length"
            :pending-request-loading="pendingloading"
            :showBulkUpload="true"
            :bulkUploadTooltip="$nova.labelsName('access_management','commentary_bulk_level_ru_upload_label_tooltip','Bulk RU level upload')"
            @bulk-upload="editData({}, 'file', [])"
            @get-pending-requests="handlePendingRequests"
            @show-faq="faqdialog = true"
            @refresh="refreshData"
            :headers="headers"
            :visibleColumns="visibleColumns"
            @update:visibleColumns="handleColumnsChange"
          />
        </div>

        <AccessRightsTable 
          ref="accessRightsTable"
          :loading="loading"
          :filtersDisabled="hierarchyLoading"
          :items="formatedData"
          :headers="filteredHeaders"
          :data-length="data.length"
          :selected-items.sync="selectedItems"
          :right="right"
          :page.sync="page"
          :meta="meta"
          :perpage="perpage"
          :hasActiveFilters="Object.keys(activeFilters).length > 0"
          @edit-data="editData"
          @loadNextPage="loadNextPage"
          @update:filters="handleTableFilterUpdate"
          @filter-menu-open="handleFilterMenuOpen"
        />
      </div>

      <SodWarningDialog v-model="sodWarningDialog" />
      
      <AccessUpdateDialog
        v-model="addeditrudialog"
        :add-edit-ru-loading="addeditruloading"
        :add-edit-ru-data="addeditrudata"
        :bulk-submit="bulksubmit"
        :mixed-sod-warning-message="mixedSodWarningMessage"
        :user-changes="userChanges"
        :ru-update-error-data="ruUpdateErrorData"
        :ru-id-code-map="ruidcodemap"
        :user-list="userlist"
        :filtered-user-list="filteredUserListArr"
        :add-user-value.sync="adduservalue"
        @update-user-access="updateUserAccessChange"
        @remove-access="removeAccess"
        @undo-change="undoChange"
        @update:addUsertype="addusertype = $event"
        @update:addUserValue="adduservalue = $event"
        @add-user="addUser"
      />

      <AddUserDialog
        v-model="adduserdialog"
        :filtered-user-list="filteredUserListArr"
        :add-user-value.sync="adduservalue"
        @add-user="addUser"
      />

      <PendingRequestsDialog
        v-model="pendingdialog"
        :pending-request-list="pendingrequestlist"
        :pending-loading="pendingloading"
        @pending-loading="setPendingLoading"
      />

      <BulkUploadDialog
        v-model="bulksubmitrudialog"
        :bulk-submit-ru-file-data.sync="bulksubmitrufiledata"
        :bulk-submit-ru-loading.sync="bulksubmitruloading"
        :bulk-submit-ru-file.sync="bulksubmitrufile"
        :bulk-submit-ru-file-error.sync="bulksubmitrufileerror"
        :bulk-submit-ru-file-warn.sync="bulksubmitrufilewarn"
        :bulk-submit-headers="bulkSubmitHeaders"
        :bulk-submit-ru-file-error-flag.sync="bulksubmitrufileerrorflag"
        :empty-ru-code.sync="emptyRuCode"
        :rucodeidmap="rucodeidmap"
        :rucodenamemap="rucodenamemap"
        :ruid-data-map="ruidDataMap"
        :formated-data="formatedData"
        :useremailidmap="useremailidmap"
        @update-user-access="updateUserAccessChange"
        @re-upload-file="reUploadFile"
      />

      <AllAccessDownloadDialog
        v-model="allaccessdownloaddialog"
        :all-access-download-list="allaccessdownloadlist"
        :all-access-download-loading="allaccessdownloadloading"
        @download-all-access="downloadAllAccess"
        @download-file="downloadAllAccess" 
      />

      <FaqDrawer
        v-model="faqdialog"
        :loading="loading"
      />


    </div>
  </div>
</template>

<script>
import CountToolbar from '../GlSelection/CountToolbar.vue';
import AccessRightsTable from './components/AccessRightsTable.vue';
import SodWarningDialog from './components/SodWarningDialog.vue';
import AccessUpdateDialog from './components/AccessUpdateDialog.vue';
import AddUserDialog from './components/AddUserDialog.vue';
import PendingRequestsDialog from './components/PendingRequestsDialog.vue';
import BulkUploadDialog from './components/BulkUploadDialog.vue';
import AllAccessDownloadDialog from './components/AllAccessDownloadDialog.vue';
import FaqDrawer from './components/FaqDrawer.vue';
import {ACCESS_CHANGE} from "../../utils/constants"
import { SOD } from "../../utils/constants";
import helpers from '../../utils/helpers';
import { ensureAccessHierarchy, buildHierarchyMaps } from '../../utils/helper';
import PageHeader from '../../components/PageHeader.vue';
// import cfilter from './Filter'
export default {
  name: 'reportingunits',
  data: function(){
    return {
      pagename:'access_management',
      right: "commentary_reportingunit",
      loading: true,
      selectedItems: [],
      data: [],
      userlist: {},
      userlistarr: {},
      useremailidmap: {},
      // Guard flag: prevents activated() from calling refreshData() on initial mount
      // since created() already handles it. Set to false after first activation.
      isFirstActivation: true,
      // Server-side pagination state
      page: 0,
      perpage: 25,
      dataMeta: { totalCount: 0 },
      filterDebounceTimer: null,
      activeFilters: {},
      hierarchyLoading: true,
      // Name-to-ID maps for filter conversion (accumulated across pages)
      networkNameIdMap: {},
      regionNameIdMap: {},
      countryNameIdMap: {},
      // RU filter list built from hierarchy data
      ruFilterList: [],
      addeditrudialog: false,
      sodWarningDialog: false,
      addeditruloading: false,
      addeditrudata: {},
      userdatachange_submitter: [],
      userdatachange_approver: [],
      userdatachange_regional_approver: [],
      userdatachange_manager: [],
      addeditruerror: {},

      adduserdialog: false,
      addusertype: '',
      adduservalue: '',
      rucodenamemap: {},
      rucodeidmap: {},
      ruidcodemap: {},

      bulksubmitrudialog: false,
      bulksubmitruloading: false,
      bulksubmitrufileerrorflag: false,
      bulksubmitrufile: null,
      bulksubmitrufiledata: [],
      bulksubmitrufileerror: [],
      bulksubmitrufilewarn: [],
      bulksubmitrufilecolumns: ["rucode", "runame", "l_preparer", "l_approver", "r_approver", "manager"],
      bulkSubmitHeaders: [
        { text: this.$nova.labelsName('access_management','commenrary_ru_label','RU') + ' Code', value: 'rucode', sortable: false },
        { text: this.$nova.labelsName('access_management','commenrary_ru_label','RU') + ' Name', value: 'runame', sortable: false },
        { text: this.$nova.labelsName('access_management','commentary_local_preparer_label','Local Preparer'), value: 'l_preparer', sortable: false },
        { text: this.$nova.labelsName('access_management','commentary_local_approver_label','Local Approver'), value: 'l_approver', sortable: false },
        { text: this.$nova.labelsName('access_management','commentary_regional_approver_label','Regional Approver'), value: 'r_approver', sortable: false },
        { text: 'Manager', value: 'manager', sortable: false },
      ],
      fileprocessing: {},

      bulksubmit: false,
      filesubmit: false,
      pendingrequestlist: [],
      pendingdialog: false,
      pendingloading: false,
      formatedData: [],
      headers: [
        {
          value: "indexno",
          text: "S.No",
          sortable: false,
          filterable: false,
        },
        {
          value: "ru_details",
          text: this.$nova.labelsName('access_management','commentary_ru_code_label','RU Code') + ' & Description',
          sortable: false,
          filterable: true,
          lock: true,
          width: "250px",
        },
        {
          value: "submitterFew",
          text: this.$nova.labelsName('access_management','commentary_local_preparer_label','Local Preparers'),
          sortable: false,
          filterable: false,
          lock: true,
          alignment: "text-left",
        },
        {
          value: "approverFew",
          text: this.$nova.labelsName('access_management','commentary_local_approver_label','Local Approvers'),
          sortable: false,
          filterable: false,
          lock: true,
          alignment: "text-left",
        },
        {
          value: "regional_approverFew",
          text: this.$nova.labelsName('access_management','commentary_regional_approver_label','Regional Approver'),
          sortable: false,
          filterable: false,
          lock: true,
          alignment: "text-left",
        },
        {
          value: "managerFew",
          text: "Manager",
          sortable: false,
          filterable: false,
          lock: true,
          alignment: "text-left",
        },
        {
          value: "sodEnabled",
          text: "SOD Status",
          sortable: false,
          filterable: true,
          lock: true,
          alignment: "text-left",
        },
        {
          value: "network",
          text: this.$nova.labelsName('access_management','division_label','Network'),
          sortable: false,
          filterable: true,
          lock: true,
        },
        {
          value: "region",
          text: this.$nova.labelsName('access_management','region_label','Region'),
          sortable: false,
          filterable: true,
          lock: true,
        },
        {
          value: "country",
          text: this.$nova.labelsName('access_management','country_label','Country'),
          sortable: false,
          filterable: true,
          lock: true,
        },
        {
          value: "currency",
          text: "Currency",
          sortable: false,
          filterable: true,
          lock: false,
          visible: false,
        },
        {
          value: "created_at",
          text: "Created At",
          sortable: false,
          filterable: true,
          datatype: "date",
          lock: false,
          visible: false,
        },
        {
          value: "updated_at",
          text: "Updated At",
          sortable: false,
          filterable: true,
          datatype: "date",
          lock: false,
          visible: false,
        },
        {
          value: "action",
          text: "Action",
          sortable: false,
          datatype: "action",
          lock: true,
          visible: false,
          alignment: "text-center",
        },
      ],

      // selectedrole: "",
      // role: [],
      // rolelist: {},
      // selectedyear: "",
      // year: [],
      // yearlist: {},
      // selectedperiod: "",
      // period: [],
      // perioddata: [],
      // periodlist: {},
      // selectednetwork: "",
      // network: [],
      // networkdata: [],
      // networklist: {},
      // selectedregion: "",
      // region: [],
      // regiondata: [],
      // regionlist: {},
      // selectedcountry: "",
      // country: [],
      // countrydata: [],
      // countrylist: {},
      // selectedreportingunit: "",
      // reportingunit: [],
      // reportingunitdata: [],
      // reportingunitlist: {},
      allaccessdownloaddialog: false,
      allaccessdownloadloading: false,
      allaccessdownloadlist: [],
      allRUDownloadPeriod: null,
      faqdialog:false,
      emptyRuCode:false,
      ruUpdateErrorData:[],
      ruidDataMap: {},
      mixedSodWarningMessage:SOD.MESSAGES.SOD_MIXED_WARNING.replace('ReportingUnit', this.$nova.labelsName('my_reporting_units_page', 'ru_entity_label', 'Reporting Unit')).replace('RU', this.$nova.labelsName('access_management','commenrary_ru_label','RU')),
    }
  },
  components: {
    CountToolbar,
    AccessRightsTable,
    SodWarningDialog,
    AccessUpdateDialog,
    AddUserDialog,
    PendingRequestsDialog,
    BulkUploadDialog,
    AllAccessDownloadDialog,
    FaqDrawer,
    PageHeader,
    // cfilter
  },
  activated() {
    // activated fires on both initial mount and reactivation (keep-alive).
    // Skip the first call since created() already handles it.
    if (!this.isFirstActivation) {
      this.refreshData();
    }
    this.isFirstActivation = false;
    // Ensure access hierarchy is loaded for complete network/region/country filter lists
    this.loadAccessHierarchy();
  },
  created() {
    this.refreshData();
    // Load access hierarchy for complete network/region/country filter lists
    this.loadAccessHierarchy();
  },
  methods: {
    refreshData() {
      this.activeFilters = {};
      this.networkNameIdMap = {};
      this.regionNameIdMap = {};
      this.countryNameIdMap = {};
      this.page = 0;
      this.getData();
    },
    /**
     * Loads access hierarchy data (network, region, country) from the Vuex store.
     * If the hierarchy data already exists in the store, uses it directly.
     * If not, dispatches the fetchAccessHierarchy action and then populates local maps.
     * This ensures complete filter lists across all pages, not just the current page.
     */
    async loadAccessHierarchy() {
      this.hierarchyLoading = true;
      try {
        const hierarchyData = await ensureAccessHierarchy(this.$store, this.axios);
        const maps = buildHierarchyMaps(hierarchyData, {
          networkNameIdMap: this.networkNameIdMap,
          regionNameIdMap: this.regionNameIdMap,
          countryNameIdMap: this.countryNameIdMap,
        });
        this.networkNameIdMap = maps.networkNameIdMap;
        this.regionNameIdMap = maps.regionNameIdMap;
        this.countryNameIdMap = maps.countryNameIdMap;
        // Build RU filter list from hierarchy data
        this.ruFilterList = (hierarchyData.reportingunitlist || []).map(ru => ({
          name: (ru.code || '') + ' ' + (ru.name || ''),
          value: ru._id,
        }));
      } catch (error) {
        console.error('[AccessRights]: loadAccessHierarchy error', error);
      } finally {
        this.hierarchyLoading = false;
      }
    },
    setPendingLoading(v) {
      this.pendingloading = v;
    },
    handlePendingRequests() {
      this.pendingdialog = true;
      this.getPendingApprovalData();
    },
    async getData() {
      this.loading = true;
      this.selectedItems = [];
      this.pendingrequestlist = [];
      try {
        // Step 1: Fetch form data (user list)
        const formDt = await helpers.apiGet.call(this, "/v2/varianceanalysis/reportingunit/getformdata");
        if (formDt.data.status === "success") {
          let ndt = formDt.data.data[0] || {};
          this.userlist = {};
          this.userlistarr = ndt.users || [];
          let colors = this.$nova.getColors(this.userlistarr.length, 0.2);
          this.useremailidmap = {};
          for (let i = 0; i < this.userlistarr.length; i++) {
            const el = this.userlistarr[i];
            this.useremailidmap[el.email] = el._id;
            el.newdisplay = el.email;
            if (el.name) el.newdisplay = el.newdisplay + " - " + el.name;
            this.userlistarr[i].newdisplay = el.newdisplay;
            this.userlist[el._id] = el;
            this.userlist[el._id].color = colors[i];
          }
        } else {
          throw new Error(formDt.data.message || "Error reading data");
        }

        // Step 2: Fetch reporting units with server-side pagination
        const filterPayload = this.buildFilterPayload();
        const ruDt = await helpers.apiGet.call(this, "/v3/varianceanalysis/reportingunit/getalllist", filterPayload);
        if (ruDt.data.status === "success") {
          this.data = ruDt.data.data;
          this.dataMeta = ruDt.data.meta || { totalCount: ruDt.data.data.length };
          this.formateData();
        } else {
          throw new Error(ruDt.data.message || "Error reading data");
        }
      } catch (err) {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log('[AccessRights]: getData error', err);
      } finally {
        this.loading = false;
      }
    },
    /**
     * Builds a filter payload combining pagination params with active column filters.
     * Converts display names to IDs for backend filtering.
     * @returns {Object} Filter payload for the API
     */
    buildFilterPayload() {
      const filterPayload = {
        limit: this.perpage,
        page: this.page,
      };

      if (this.activeFilters && Object.keys(this.activeFilters).length > 0) {
        // Network filter
        if (this.activeFilters.network?.length > 0) {
          filterPayload.network = this.activeFilters.network
            .map(name => this.networkNameIdMap[name])
            .filter(id => id);
        }
        // Region filter
        if (this.activeFilters.region?.length > 0) {
          filterPayload.region = this.activeFilters.region
            .map(name => this.regionNameIdMap[name])
            .filter(id => id);
        }
        // Country filter
        if (this.activeFilters.country?.length > 0) {
          filterPayload.country = this.activeFilters.country
            .map(name => this.countryNameIdMap[name])
            .filter(id => id);
        }
        // RU filter - values are reporting unit _ids set by handleFilterMenuOpen
        if (this.activeFilters.ru_details?.length > 0) {
          filterPayload.ruids = this.activeFilters.ru_details.filter(id => id);
        }
      }

      return filterPayload;
    },
    /**
     * Fetches data with active filters applied (for pagination & filter changes).
     */
    async getFilteredData() {
      this.loading = true;
      try {
        const filterPayload = this.buildFilterPayload();
        const dt = await helpers.apiGet.call(this, "/v3/varianceanalysis/reportingunit/getalllist", filterPayload);
        if (dt.data.status === "success") {
          this.data = dt.data.data;
          this.dataMeta = dt.data.meta || { totalCount: dt.data.data.length };
          this.formateData();
        } else {
          throw new Error(dt.data.message || "Error reading data");
        }
      } catch (err) {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log('[AccessRights]: getFilteredData error', err);
      } finally {
        this.loading = false;
      }
    },
    /**
     * Handles page change from DataTableNew pagination
     * @param {Object} d - Contains { page } (0-based index)
     */
    loadNextPage(d) {
      const newPage = d?.page || 0;
      this.page = newPage;
      this.getFilteredData();
    },
    /**
     * When a filter menu opens, load the full reporting unit list from the
     * hierarchy data in the Vuex store (same source as Filter.vue's reportingunitlist).
     */
    handleFilterMenuOpen(key) {
      if (key === 'ru_details') {
        const hierarchyData = this.$store.state.m_varianceanalysis?.actualhierarchydata
          || this.$store.state.varianceanalysis?.actualhierarchydata || {};
        const rulist = hierarchyData.reportingunitlist || [];
        if (rulist.length > 0) {
          const filterList = rulist.map(ru => ({
            name: (ru.code || '') + ' ' + (ru.name || ''),
            value: ru._id,
          }));
          this.$refs.accessRightsTable?.setExternalFilterItems('ru_details', filterList);
        }
      }
    },
    /**
     * Handles table column filter updates with debounce.
     * Guards against re-fetching when filters haven't actually changed (prevents
     * the loop caused by DataTableNew emitting update:filters on mount/destroy).
     * @param {Object} filters - Filter object from DataTableNew
     */
    handleTableFilterUpdate(filters) {
      // Ignore filter events emitted by DataTableNew during its destroy/create
      // lifecycle while we are already mid-fetch. These are spurious resets.
      if (this.loading) return;

      if (this.filterDebounceTimer) {
        clearTimeout(this.filterDebounceTimer);
      }
      this.filterDebounceTimer = setTimeout(async () => {
        if (!filters || Object.keys(filters).length === 0) {
          // If there are no active filters, nothing to clear — skip re-fetch
          if (Object.keys(this.activeFilters).length === 0) return;
          this.activeFilters = {};
          this.page = 0;
          await this.getFilteredData();
          return;
        }
        this.activeFilters = { ...filters };
        this.page = 0;
        await this.getFilteredData();
      }, 500);
    },
    getPendingApprovalData() {
      this.pendingloading = true;
      this.pendingrequestlist = [];
      helpers.apiGet.call(this, "/v2/varianceanalysis/reportingunit/getpendingaccessrequest").then(dt => {
        if(dt.data.status === "success") {
          this.pendingrequestlist = dt.data.data || [];
        }
        else throw new Error (dt.data.message || "Error reading pending request data");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.pendingloading = false;
      })
    },
    formateData() {
      let ArrayTemp = [];
      this.rucodenamemap = {};
      // Accumulate name-to-id maps (don't reset) so filters survive page changes.
      // Clone existing maps so Vue 2 detects the replacement as a reactive change.
      const newNetworkMap = { ...this.networkNameIdMap };
      const newRegionMap = { ...this.regionNameIdMap };
      const newCountryMap = { ...this.countryNameIdMap };
      const pageOffset = this.page * this.perpage;
      
      this.data.forEach((reportingUnit, k) => {
        this.rucodenamemap[reportingUnit.code] = reportingUnit.name;
        this.rucodeidmap[reportingUnit.code] = reportingUnit._id;
        this.ruidcodemap[reportingUnit._id] = reportingUnit.code;
        this.ruidDataMap[reportingUnit._id] = reportingUnit;
        
        // Build name-to-id mappings for filters (accumulated across pages)
        if (reportingUnit.network_detail?.name && reportingUnit.network_detail?._id) {
          newNetworkMap[reportingUnit.network_detail.name] = reportingUnit.network_detail._id;
        }
        if (reportingUnit.region_detail?.name && reportingUnit.region_detail?._id) {
          newRegionMap[reportingUnit.region_detail.name] = reportingUnit.region_detail._id;
        }
        if (reportingUnit.country_detail?.name && reportingUnit.country_detail?._id) {
          newCountryMap[reportingUnit.country_detail.name] = reportingUnit.country_detail._id;
        }
        
        ArrayTemp.push({
          __key: k,
          __formatedkey: k,
          _id: reportingUnit._id,
          indexno: pageOffset + k + 1,
          code: reportingUnit.code,
          name: reportingUnit.name,
          ru_details: reportingUnit.code + ' ' + reportingUnit.name,
          network: (reportingUnit.network_detail || {}).name || "NA",
          region: (reportingUnit.region_detail || {}).name || "NA",
          country: (reportingUnit.country_detail || {}).name || "NA",
          submitterids: reportingUnit.submitter || [],
          submitter: this.getCodeName(reportingUnit.submitter || []),
          submitterFew: this.getCodeName(reportingUnit.submitter || [], 2),
          __submitterplus: ((reportingUnit.submitter || []).length - 2),
          approverids: reportingUnit.approver || [],
          approver: this.getCodeName(reportingUnit.approver || []),
          approverFew: this.getCodeName(reportingUnit.approver || [], 2),
          __approverplus: ((reportingUnit.approver || []).length - 2),
          regional_approverids: reportingUnit.regional_approver || [],
          regional_approver: this.getCodeName(reportingUnit.regional_approver || []),
          regional_approverFew: this.getCodeName(reportingUnit.regional_approver || [], 2),
          __regional_approverplus: ((reportingUnit.regional_approver || []).length - 2),
          managerids: reportingUnit.manager || [],
          manager: this.getCodeName(reportingUnit.manager || []),
          managerFew: this.getCodeName(reportingUnit.manager || [], 2),
          __managerplus: ((reportingUnit.manager || []).length - 2),
          currency: reportingUnit.currency,
          sodEnabled: (reportingUnit?.sodEnabled === true || reportingUnit?.sodEnabled === null) ? SOD.STATUS.ENABLED : SOD.STATUS.DISABLED,
          isSodEnabled: (reportingUnit?.sodEnabled === true || reportingUnit?.sodEnabled === null),
          created_at: this.toISOConverter(reportingUnit.created_at) + " IST",
          updated_at: this.toISOConverter(reportingUnit.updated_at) + " IST",
        });
      });
      
      // Replace maps with new objects so Vue 2 detects the change
      this.networkNameIdMap = newNetworkMap;
      this.regionNameIdMap = newRegionMap;
      this.countryNameIdMap = newCountryMap;
      
      this.formatedData = ArrayTemp;
    },
    getCodeName(dt, limit){
      return dt.slice(0, limit || (dt || []).length).map(el => {return {
        _id: el,
        code: (((this.userlist[el] || {}).email || "UN").split("") || []).slice(0, 2).map((word) => word[0].toUpperCase()).join(""),
        name: (this.userlist[el] || {}).email || "Unknown User",
        color: (this.userlist[el] || {}).color || 'rgba(0,0,0,0.2)'
      }})
    },
    editData(v, type, ru) {
      this.bulksubmitrufiledata = [];
      this.bulksubmitrufileerrorflag = false;
      this.emptyRuCode=false,
      // this.editablegls = [];
      // this.ruleveledit.local = false;
      // this.ruleveledit.regional = false;
      // this.ruleveledit.enable = false;
      this.userdatachange_submitter = [];
      this.userdatachange_approver = [];
      this.userdatachange_regional_approver = [];
      this.userdatachange_manager = [];
      this.ruUpdateErrorData = [];
      if(type === "bulk") {
        this.bulksubmit = true;
        this.filesubmit = false;
        this.addeditrudata={};
        this.addeditrudata.__type = type;
        this.addeditruerror={};
        // get all ru details from ruiddatamap of ru id array
        const ruDataList = ru?.map(reportingUnitId => this.ruidDataMap[reportingUnitId])?.filter(ruData => ruData);
        const isAllRuSodEnabled = ruDataList?.every(ruData => (ruData.sodEnabled === true || ruData.sodEnabled === null));
        const isAllRuSodDisabled = ruDataList?.every(ruData => (ruData.sodEnabled !== true && ruData.sodEnabled !== null));
        const isSodMixed = !isAllRuSodEnabled && !isAllRuSodDisabled;
        // if all rus are sod enabled , then set sod enabled true
        // if all rus are sod disabled , then set sod enabled false
        // if mixed , then set sod enabled true and sod mixed true
        this.addeditrudata.__sodEnabled = (isAllRuSodEnabled || isSodMixed) ? true : (isAllRuSodDisabled ? false : true);
        this.addeditrudata.__sodMixed = isSodMixed;

        if (isSodMixed) {
          this.sodWarningDialog = true;
          return;
        }
      }
      else if(type === "single") {
        this.addeditrudata=this.$nova.deepCopyJson(v);
        this.addeditrudata.__originalsubmitter = [...(this.addeditrudata.submitter || [])];
        this.addeditrudata.__originalapprover = [...(this.addeditrudata.approver || [])];
        this.addeditrudata.__originalregional_approver = [...(this.addeditrudata.regional_approver || [])];
        this.addeditrudata.__originalmanager = [...(this.addeditrudata.manager || [])];
        this.addeditrudata.__type = type;
        this.addeditruerror={};
        this.bulksubmit = false;
        this.filesubmit = false;
        // Get SOD status for single RU
        const ruData = this.ruidDataMap[ru];
        this.addeditrudata.__sodEnabled = (ruData?.sodEnabled === true || ruData?.sodEnabled === null);
      }
      else if(type === "file") {
        this.bulksubmit = false;
        this.filesubmit = true;
        this.addeditrudata={};
        this.addeditrudata.__type = type;
        this.addeditruerror={};
        this.bulksubmitrufile = null;
        this.bulksubmitrufiledata = [];
        this.bulksubmitrufileerror = [];
        this.bulksubmitrufilewarn = [];
        this.bulksubmitrudialog = true;
      }
      if(type === "bulk" || type === "single"){
        this.addeditrudata._id = ru;
        this.addeditrudialog=true;
        // if(ru instanceof Array) this.formattedGLData = this.generateFormattedGLList({});
        // else this.getRUData(ru);
      }
    },
    getDownloadAllAccesslist() {
      this.allaccessdownloaddialog = true;
      this.allaccessdownloadloading = true;
      let url = "/v2/varianceanalysis/reportingunit/downloadallaccessexcellist/";
      helpers.apiGet.call(this, url).then(dt => {
        if(dt.data.status === "success") {
          this.allaccessdownloadlist = dt.data.data;
        }
        else throw new Error (dt.data.message || "Error loading download list");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.allaccessdownloadloading = false;
      })
    },
    downloadAllAccess(id) {
      this.allaccessdownloadloading = true;
      let url = "/v2/varianceanalysis/reportingunit/downloadallaccessexcel/";
      if(id) url = url + id;
      this.axios.post(url, {filter: {}}).then(dt => {
        if(dt.data.status === "success") {
          this.getDownloadAllAccesslist();
        }
        else throw new Error (dt.data.message || "Error generating download");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.allaccessdownloadloading = false;
      })
    },   
    updateUserAccessChange() {
      this.addeditruloading = true;
      let newdata = {
        reportingunit: this.addeditrudata._id || '',
      };
      if(this.addeditrudata.__type === ACCESS_CHANGE.TYPE.SINGLE || this.addeditrudata.__type === ACCESS_CHANGE.TYPE.BULK){
        newdata.type = ACCESS_CHANGE.REQUEST_TYPE.ACCESS_CHANGE;
        if(this.bulksubmit) {
          newdata.bulk = true;
          newdata.type = ACCESS_CHANGE.REQUEST_TYPE.BULK_ACCESS_CHANGE;
        }
        let add = {};
        let remove = {};
        let usercngdt = {
          submitter: this.userdatachange_submitter,
          approver: this.userdatachange_approver,
          regional_approver: this.userdatachange_regional_approver,
          manager: this.userdatachange_manager,
        }
        for (const k in usercngdt) {
          if (Object.hasOwnProperty.call(usercngdt, k)) {
            const el = this["userdatachange_"+k];
            for (const i of el) {
              if(i.action === ACCESS_CHANGE.ACTION.REMOVE){
                if(i.user?._id){
                  remove[k] = remove[k] || [];
                  remove[k].push(i.user._id);
                }
              } else if(i.action === ACCESS_CHANGE.ACTION.ADD){
                if(i.user?._id){
                  add[k] = add[k] || [];
                  add[k].push(i.user._id);
                }
              }
            }
          }
        }
        for (const k in add) {
          if (Object.hasOwnProperty.call(add, k)) {
            const el = add[k];
            if(el.length === 0) delete add[k];
          }
        }
        for (const k in remove) {
          if (Object.hasOwnProperty.call(remove, k)) {
            const el = remove[k];
            if(el.length === 0) delete remove[k];
          }
        }
        if(Object.keys(add).length > 0) newdata.adduser = add;
        if(Object.keys(remove).length > 0) newdata.removeuser = remove;
      }
      else if(this.addeditrudata.__type === ACCESS_CHANGE.TYPE.FILE) {
        this.bulksubmitruloading = true;
        newdata.type = ACCESS_CHANGE.REQUEST_TYPE.FILE_ACCESS_CHANGE;
        newdata.bulk = true;
        let ndt = [];
        newdata.reportingunit = [];
        for (const accessChangeDetails of this.bulksubmitrufiledata) {
          let td = {};
          td.rucode = this.rucodeidmap[accessChangeDetails.rucode];
            newdata.reportingunit.push(td.rucode);
            if(Object.prototype.hasOwnProperty.call(accessChangeDetails, ACCESS_CHANGE.ROLE.LOCAL_PREPARER_IDS)) td.preparer = accessChangeDetails[ACCESS_CHANGE.ROLE.LOCAL_PREPARER_IDS] || undefined;
            if(Object.prototype.hasOwnProperty.call(accessChangeDetails, ACCESS_CHANGE.ROLE.LOCAL_APPROVER_IDS)) td.approver = accessChangeDetails[ACCESS_CHANGE.ROLE.LOCAL_APPROVER_IDS] || undefined;
            if(Object.prototype.hasOwnProperty.call(accessChangeDetails, ACCESS_CHANGE.ROLE.REGIONAL_APPROVER_IDS)) td.regional_approver = accessChangeDetails[ACCESS_CHANGE.ROLE.REGIONAL_APPROVER_IDS] || undefined;
            if(Object.prototype.hasOwnProperty.call(accessChangeDetails, ACCESS_CHANGE.ROLE.MANAGER_IDS)) td.manager = accessChangeDetails[ACCESS_CHANGE.ROLE.MANAGER_IDS] || undefined;
            ndt.push(td);
        }
        newdata.users = ndt;
      }
      this.axios.post("/v2/varianceanalysis/reportingunit/saveaccessupdateforapproval", {data: newdata}).then(dt => {
        if(dt.data.status === "success") {
          this.$store.commit("sbSuccess", "Update request raised for approval");
          this.addeditrudialog = false;
          this.bulksubmitrudialog = false;
        }else {
          let data =  dt.data.data || []
          
          if(data.length>0){
            if (this.addeditrudata.__type === "single" || this.addeditrudata.__type === 'bulk'){
              this.ruUpdateErrorData = [];
              if(data.length>0){
                this.ruUpdateErrorData = data || [];
              }

            }
            else if (this.addeditrudata.__type === "file"){
              this.bulksubmitrufileerrorflag = true
              data.forEach((ruErrorData) => {
                let index = this.bulksubmitrufiledata.findIndex(item => item.ruid === ruErrorData.rucode);
                console.log(data)
                if (index !== -1) {
                  let ruUploadedData = this.bulksubmitrufiledata[index];

                  ruErrorData.userids.forEach((user) => {
                    const roleTypes = ['l_preparer', 'l_approver', 'r_approver', 'manager'];
                    const roleIds = ['l_preparer_ids', 'l_approver_ids', 'r_approver_ids', 'manager_ids'];

                    roleTypes.forEach((role, i) => {
                      let userIndex = (ruUploadedData[roleIds[i]] || []).indexOf(user);
                      if (userIndex !== -1) {
                        if (!Object.prototype.hasOwnProperty.call(this.bulksubmitrufileerror[index], role)) {
                          this.bulksubmitrufileerror[index][role] = [];
                        }
                        while (this.bulksubmitrufileerror[index][role].length <= userIndex) {
                          this.bulksubmitrufileerror[index][role].push("");
                        }

                        this.bulksubmitrufileerror[index][role][userIndex] = `User doesn't have access to this ${this.$nova.labelsName('access_management','commenrary_ru_label','RU')}`;
                      }
                    });
                  });
                }
              });
            }
            this.addeditruloading = false;
          }
          throw new Error (dt.data.message ? this.$nova.identifyAndRemapLabelName(this.$constants.BULK_FILE_TEMPLATES.ERROR_MESSAGES, dt.data.message, true) : "Error raising change request");
        }
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.addeditruloading = false;
        this.bulksubmitruloading = false;
        this.getPendingApprovalData();
      })
    },
    // getRUData(id) {
    //   this.addeditruloading = true;
    //   this.addeditrudialog = true;
    //   this.axios.post("/v2/varianceanalysis/materiality/getmy/"+id).then(dt => {
    //     if(dt.data.status === "success") {
    //       let ndt = {};
    //       for (const i of dt.data.data) {
    //         ndt[i._id] = i;
    //       }
    //       this.formattedGLData = this.generateFormattedGLList(ndt);
    //     }
    //     else throw new Error ("Error reading materiality data");
    //   }).catch(err => {
    //     this.$store.commit("sbError", err.message || err || "Unknown error!");
    //     console.log(err);
    //   }).finally(() => {
    //     this.addeditruloading = false;
    //   })
    // },
    // editData(v) {
    //   this.addeditrudialog=true;
    //   this.addeditrudata=this.$nova.deepCopyJson(v);
    //   this.addeditrudata.__originalsubmitter = [...(this.addeditrudata.submitter || [])];
    //   this.addeditrudata.__originalapprover = [...(this.addeditrudata.approver || [])];
    //   this.addeditrudata.__originalmanager = [...(this.addeditrudata.manager || [])];
    //   this.addeditruerror={};
    //   if(this.addeditrudata.control_thresholds_percent) this.addeditrudata.control_thresholds_percent = this.addeditrudata.control_thresholds_percent*100;
    //   if(this.addeditrudata.management_thresholds_percent) this.addeditrudata.management_thresholds_percent = this.addeditrudata.management_thresholds_percent*100;
    // },
    // updateUserAccessChange() {
    //   this.addeditruloading = true;
    //   let newdata = this.userdatachange || {};
    //   this.axios.post("/v2/varianceanalysis/reportingunit/updateuseraccesschange/"+this.addeditrudata._id, {data: [newdata]}).then(dt => {
    //     if(dt.data.status === "success") {
    //       this.$store.commit("sbSuccess", "Update request raised for approval");
    //       this.addeditrudialog = false;
    //     }else throw new Error (dt.data.message || "Error raising change request");
    //   }).catch(err => {
    //     this.$store.commit("sbError", err.message || err || "Unknown error!");
    //     console.log(err);
    //   }).finally(() => {
    //     this.addeditruloading = false;
    //   })
    // },
    // bulkUpdateAccess() {
    //   this.bulkchangeloading = true;
    //   let newdata = {type: this.addusertype, data: this.bulkchange};
    //   let fltr = {count: this.filtereddata.length};
    //   if(this.selectednetwork !== "all") fltr.network = this.selectednetwork;
    //   if(this.selectedregion !== "all") fltr.region = this.selectedregion;
    //   if(this.selectedcountry !== "all") fltr.country = this.selectedcountry;
    //   this.axios.post("/v2/varianceanalysis/reportingunit/updatebulkuseraccesschange/", {data: newdata, filter: fltr}).then(dt => {
    //     if(dt.data.status === "success") {
    //       this.$store.commit("sbSuccess", "Bulk update request raised for approval");
    //       this.bulkchangedialog = false;
    //     }else throw new Error (dt.data.message || "Error raising bulk change request");
    //   }).catch(err => {
    //     this.$store.commit("sbError", err.message || err || "Unknown error!");
    //     console.log(err);
    //   }).finally(() => {
    //     this.bulkchangeloading = false;
    //   })
    // },
    removeAccess(k, type) {
      this["userdatachange_"+type] = this["userdatachange_"+type] || [];
      this["userdatachange_"+type].push({action: 'remove', type: type, user: this.addeditrudata[type][k]});
      this.addeditrudata[type].splice(k,1);
    },
    addUser() {
      let userid = this.adduservalue;
      let type = this.addusertype;
      this["userdatachange_"+type] = this["userdatachange_"+type] || [];
      this["userdatachange_"+type].push({action: 'add', type: type, user: this.getCodeName([userid])[0]});
      this.addeditrudata.__changeadd = this.addeditrudata.__changeadd || [];
      this.addeditrudata.__changeadd.push(userid);
      this.addeditrudata[type] = this.addeditrudata[type] || [];
      this.addeditrudata[type].push({});
      this.addeditrudata[type].pop();
      this.addusertype = '';
      this.adduservalue = '';
      this.adduserdialog = false;
    },
    undoChange(id, k, type, action){
      if(action === "remove")this.addeditrudata[type].push(this.getCodeName([id])[0]);
      else if(action === "add"){
        let ak = (this.addeditrudata.__changeadd || []).indexOf(id);
        if(ak > -1) this.addeditrudata.__changeadd.splice(ak,1);
      }
      (this["userdatachange_"+type] || []).splice(k,1);
      if(this["userdatachange_"+type].length === 0) delete this["userdatachange_"+type];
      this.sanitizeChangeList();
    },
    sanitizeChangeList(){
      let alluserids = [...(this.addeditrudata["submitter"] || []).map(d => d._id), ...(this.addeditrudata["approver"] || []).map(d => d._id), ...(this.addeditrudata["regional_approver"] || []).map(d => d._id), ...(this.addeditrudata["manager"] || []).map(d => d._id)];
      this["userdatachange_"+"submitter"] = (this["userdatachange_"+"submitter"] || []).filter(dt => (alluserids.indexOf(dt.user?._id) === -1)?true:false);
      this["userdatachange_"+"approver"] = (this["userdatachange_"+"approver"] || []).filter(dt => (alluserids.indexOf(dt.user?._id) === -1)?true:false);
      this["userdatachange_"+"regional_approver"] = (this["userdatachange_"+"regional_approver"] || []).filter(dt => (alluserids.indexOf(dt.user?._id) === -1)?true:false);
      this["userdatachange_"+"manager"] = (this["userdatachange_"+"manager"] || []).filter(dt => (alluserids.indexOf(dt.user?._id) === -1)?true:false);
      this.addeditrudata.__changeadd = (this.addeditrudata.__changeadd || []).filter(dt => (alluserids.indexOf(dt) === -1)?true:false);
    },


    toISOConverter(rawDate) {
      try {
        const date = new Date(rawDate);

        // Extract date components
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // January is 0
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();

        // Format the date as desired (e.g., YYYY-MM-DD HH:mm:ss)
        const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day} ${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

        return formattedDate
      } catch (error) {
        console.error("Error:", error.message);
      }

    },
    handleColumnsChange(newVisibleColumns) {
      this.headers = this.headers.map(h => {
        if (h.lock) return h; 
        return {
          ...h,
          visible: newVisibleColumns.includes(h.value)
        };
      });
    },
    reUploadFile() {
      this.bulksubmitrufile = null;
      this.bulksubmitrufiledata = [];
      this.bulksubmitrufileerror = [];
      this.bulksubmitrufilewarn = [];
      this.bulksubmitrufileerrorflag = false;
      this.emptyRuCode = false;
    }
  },
  beforeDestroy() {
    if (this.filterDebounceTimer) {
      clearTimeout(this.filterDebounceTimer);
      this.filterDebounceTimer = null;
    }
    this.formatedData = [];
    this.data = [];
    this.activeFilters = {};
  },
  computed: {
    meta() {
      return this.dataMeta || { totalCount: 0 };
    },
    userChanges() {
      return {
        submitter: this.userdatachange_submitter,
        approver: this.userdatachange_approver,
        regional_approver: this.userdatachange_regional_approver,
        manager: this.userdatachange_manager
      }
    },
    visibleColumns() {
      return this.headers.filter(h => h.visible !== false).map(h => h.value);
    },
    /**
     * Returns headers with filterList injected for network/region/country columns
     * so DataTableNew shows all known values across pages (not just current page).
     */
    filteredHeaders() {
      const filterListMap = {
        ru_details: this.ruFilterList,
        network: Object.keys(this.networkNameIdMap).map(name => ({ name, value: name })),
        region: Object.keys(this.regionNameIdMap).map(name => ({ name, value: name })),
        country: Object.keys(this.countryNameIdMap).map(name => ({ name, value: name })),
      };
      return this.headers.map((header) => {
        if (filterListMap[header.value] && filterListMap[header.value].length > 0) {
          return { ...header, filterList: filterListMap[header.value] };
        }
        return header;
      });
    },
    filteredUserListArr: function(){
      let rdt = [];
      if(this.addusertype){
        const isSodEnabled = this.addeditrudata.__sodEnabled !== false;
        for (const k in this.userlistarr) {
          if (Object.hasOwnProperty.call(this.userlistarr, k)) {
            const el = this.userlistarr[k];
            let pushflag = true;            
            let remsubids = (this["userdatachange_"+"submitter"] || []).map(dt => dt.user?._id);
            let remappids = (this["userdatachange_"+"approver"] || []).map(dt => dt.user?._id);
            let remrappids = (this["userdatachange_"+"regional_approver"] || []).map(dt => dt.user?._id);
            let remmanids = (this["userdatachange_"+"manager"] || []).map(dt => dt.user?._id);
            if((this.addeditrudata["__original"+this.addusertype] || []).indexOf(el._id) > -1) pushflag = false;
            if(isSodEnabled){
              if((this.addeditrudata["submitterids"] || []).indexOf(el._id) > -1) pushflag = false;
              else if((this.addeditrudata["approverids"] || []).indexOf(el._id) > -1) pushflag = false;
              else if((this.addeditrudata["managerids"] || []).indexOf(el._id) > -1) pushflag = false;
              else if((this.addeditrudata["regional_approverids"] || []).indexOf(el._id) > -1) pushflag = false;
            if(this.addusertype === "submitter"){
              if(remappids.indexOf(el._id) > -1) pushflag = true;
              else if(remmanids.indexOf(el._id) > -1) pushflag = true;
              else if(remrappids.indexOf(el._id) > -1) pushflag = true;
            }else if(this.addusertype === "approver"){
              if(remsubids.indexOf(el._id) > -1) pushflag = true;
              else if(remmanids.indexOf(el._id) > -1) pushflag = true;
              else if(remrappids.indexOf(el._id) > -1) pushflag = true;
            }else if(this.addusertype === "regional_approver"){
              if(remsubids.indexOf(el._id) > -1) pushflag = true;
              else if(remmanids.indexOf(el._id) > -1) pushflag = true;
              else if(remappids.indexOf(el._id) > -1) pushflag = true;
            }else if(this.addusertype === "manager"){
              if(remsubids.indexOf(el._id) > -1) pushflag = true;
              else if(remappids.indexOf(el._id) > -1) pushflag = true;
              else if(remrappids.indexOf(el._id) > -1) pushflag = true;
            }
            if((this.addeditrudata.__changeadd || []).indexOf(el._id) > -1) pushflag = false;
           }
            if(pushflag) rdt.push(el);
          }
        }
      }
      return rdt;
    }
  },
  watch: {
    userdatachange_submitter() {
      console.log("userdatachange_submitter changed");
    },
    userdatachange_approver() {
      console.log("userdatachange_approver changed");
    },
    userdatachange_regional_approver() {
      console.log("userdatachange_regional_approver changed");
    },
    userdatachange_manager() {
      console.log("userdatachange_manager changed");
    },
    adduserdialog() {
      console.log("adduserdialog changed: ", this.adduserdialog);
    }
  }
}
</script>
<style>
.border-left-success-btn {
  border: 1px solid var(--color-success) !important;
  background: none !important;
}

.border-left-error-btn {
  border: 1px solid var(--color-error) !important;
  background: none !important;
}

.avatar-stack {
  display: flex;
  align-items: center;
}

.stack-avatar {
  background-color: #ffffff;
  border: 1px solid #CBCBCC;
  box-shadow: 0 1px 4px rgba(5, 5, 6, 0.16),
              0 1px 4px rgba(5, 5, 6, 0.08);
  margin-left: -6px; /* 👈 THIS creates overlay */
  font-weight: 600;
}

.stack-avatar:first-child {
  margin-left: 0;
}

.more-avatar {
  background-color: #f5f5f5;
  font-weight: 700;
}
.userAddBtn .v-btn__content {
  gap: 8px;
}
</style>